<div class="message is-fullwidth" style="overflow-y: auto; max-height: calc(100vh - 125px);">

  <div class="message-header" (dblclick)="toggleMinimizeFilters()">
    <p i18n>Filters</p>
    <button (click)="toggleMinimizeFilters()">
      <span class="icon is-small">
        @if (!filtersMinimized) {
          <i-feather name="chevron-up"></i-feather>
        } @else {
          <i-feather name="chevron-down"></i-feather>
        }
      </span>
    </button>
  </div>

  @if (!filtersMinimized) {
    <div class="message-body">
      <div class="is-flex is-flex-direction-row is-flex-wrap-wrap filter-row unisized-labels">
        <div class="label label-select" style="width: 700px">
          <span i18n>Object IDs</span>
          <textarea class="textarea" type="text" [ngModel]="objectIDsString"
          rows="5" (ngModelChange)="setObjectIDsString($event)"></textarea>
        </div>
        <div class="label label-select">
          <span i18n>Datasets</span>@if (dataFilters.type.length > 0) {
          <span>
          ({{ dataFilters.type.length }})</span>
        }
        <div class="select is-fullwidth is-multiple">
          <select multiple [(ngModel)]="dataFilters.type">
            <ng-container>
              @for (source of sources; track source) {
                <option [ngValue]="source.id">{{ source.label }}</option>
              }
            </ng-container>
          </select>
        </div>
      </div>
    </div>
    <div class="buttons">
      @if (!isLoadingData) {
        <button class="button is-primary" (click)="requestData()"
          [disabled]="queryButtonDisabled()">
          <strong i18n>Apply filters</strong>
        </button>
      } @else {
        <button class="button is-primary" disabled>
          <div class="loader"></div>&nbsp;
          <strong i18n>Apply filters</strong>
        </button>
      }
      &nbsp;
      <button class="button" (click)="resetDataFilters()" [disabled]="isLoadingData">
        <ng-container i18n>Reset filters</ng-container>
      </button>
    </div>
    <div>
      @if (queryButtonDisabled()) {
        <div class="columns">
          <div class="column is-italic" i18n>No ID or NDVI dataset chosen (Sentinel/Planet).</div>
        </div>
      }
    </div>
  </div>
}

<div style="height: 100%">
  <div style="overflow: auto">
    @if (allData) {
      <div class="buttons are-small is-flex is-justify-content-center">
        <button class="button is-outlined is-primary" (click)="moveChart(-1)">
          <span class="icon">
            <i-feather name="chevron-left"></i-feather>
          </span>
        </button>
        <button class="button is-outlined is-primary" (click)="exportChart()">
          <span class="icon">
            <i-feather name="download"></i-feather>
          </span>
        </button>
        <button class="button is-outlined is-primary" (click)="moveChart(1)">
          <span class="icon">
            <i-feather name="chevron-right"></i-feather>
          </span>
        </button>
      </div>
    }
    <div class="canvas-div" [ngClass]="{'invisible': !isDataLoaded}">
      <canvas id="chart" #canvas></canvas>
    </div>
  </div>
</div>

@if (allData && allData.length === 0 && isDataLoaded) {
  <div>
    <div class="columns">
      <div class="column is-italic" i18n>No NDVI data found.</div>
    </div>
  </div>
}


</div>